<template>
  <v-row>
    <v-col cols="12" sm="12" md="12" class="pb-0">
      <table-cadu
        class="municipio-ibge"
        nameTab="TabelaMunicipioIBGE"
        :loading="loading"
        :showCheck="false"
        :showDownload="true"
        :custom="true"
        :showFiltro="true"
        :ordemProp="ordem"
        :rows="rows"
        :rowsHeader="rowsHeader"
        :items="['05', '10', '15', '20']"
        :elementsPerPageProp="elementsPerPage"
        :pagina="pagina"
        :qtPaginas="qtPaginas"
        :qtResultados="qtResultados"
        @change-element="element => changeSizePageSelected(element)"
        @change-page="page => changePage(page)"
        @ordena="ordem => ordernaTable(ordem)"
        @filtro-click="$emit('filtro-click')"
        @download="$emit('download-click')"
      />
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    municipios: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      rowsHeader: [
        { text: "Código IBGE", icon: "repeat" },
        { text: "Município", icon: "repeat" },
        { text: "Região", icon: "repeat" },
        { text: "UF", icon: "repeat" }
      ],
      rows: this.municipios ? this.municipios.conteudo : [],
      pagina: this.municipios ? this.municipios.pagina : 1,
      qtPaginas: this.municipios ? this.municipios.qtPaginas : 10,
      qtResultados: this.municipios ? this.municipios.qtResultados : 5,

      elementsPerPage: "10",
      currentPage: 1,
      ordem: "desc",
      ordemStatus: "id",

      tokenBearer: localStorage.getItem("tokenBearer")
    };
  },
  watch: {
    municipios() {
      this.rows = this.municipios.conteudo;
      this.pagina = this.municipios.pagina;
      this.qtPaginas = this.municipios.qtPaginas;
      this.qtResultados = this.municipios.qtResultados;
    }
  },
  beforeMount() {
    this.paginate();
  },
  methods: {
    getArgs () {
      let args = this.geradorParams(
          {
            name: 'ordenacao',
            value: this.ordemStatus || ''
          },
          {
            name: 'direcaoOrdenacao',
            value: this.ordem || ''
          },
          {
            name: 'tamanhoPagina',
            value: this.elementsPerPage || ''
          },
          {
            name: 'pagina',
            value: this.currentPage || ''
          }
      )
      return args
    },
    geradorParams (...params) {
      let str = ''
      for (let p of params) {
          if (p.value) {
              str += `${p.name}=${p.value}&`
          }
      }
      if (params.length > 0) {
          str = str.substring(0, str.length - 1)
      }
      return str
    },
    changeSizePageSelected(element) {
      this.elementsPerPage = element;
      this.currentPage = 1;
      this.paginate();
    },
    changePage(page) {
      if (Number(page.currentPage) !== this.currentPage) {
        this.currentPage = Number(page.currentPage);
        this.paginate();
      }
    },
    ordernaTable(obj) {
      this.ordem = obj.ordem
      obj.index == 0
        ? (this.ordemStatus = "id")
        : obj.index == 1
        ? (this.ordemStatus = "nome")
        : obj.index == 2
        ? (this.ordemStatus = "regiao.nome")
        : obj.index == 3
        ? (this.ordemStatus = "regiao.estado.sigla")
        : (this.ordem = "id");

      this.paginate();
    },
    paginePadrao(){
      this.currentPage = 1
      return this.getArgs()
    },
    paginate() {
      this.$emit("paginate", this.getArgs());
    }
  }
};
</script>

<style lang="sass">
.municipio-ibge > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.municipio-ibge > .table-cadu > .table
  max-height: 240px
  overflow: auto
  table
    width: 100%
</style>